import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Label } from "./Reveal";

export const CTASection = ({ title, text, cta = "Demander un devis" }) => (
  <section data-testid="cta-section" className="noise-bg relative overflow-hidden border-y border-white/10 bg-[#0d1512]">
    <div
      className="pointer-events-none absolute inset-0 opacity-40"
      style={{ background: "radial-gradient(ellipse 60% 50% at 20% 50%, rgba(4,120,87,0.25), transparent)" }}
    />
    <div className="relative mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36">
      <Reveal>
        <Label>Votre projet commence ici</Label>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 max-w-3xl font-serif text-4xl font-light leading-[1.05] text-[#F4F4F0] md:text-6xl">
          {title || "Décrivez-nous votre projet et obtenez un accompagnement personnalisé."}
        </h2>
      </Reveal>
      {text && (
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-[#8C8C8C] md:text-lg">{text}</p>
        </Reveal>
      )}
      <Reveal delay={0.2}>
        <Link
          to="/devis"
          data-testid="cta-section-button"
          className="group relative mt-10 inline-flex overflow-hidden bg-[#047857] px-8 py-4 text-xs font-medium uppercase tracking-[0.2em] text-white"
        >
          <span className="absolute inset-0 -translate-x-full bg-[#065F46] transition-transform duration-500 ease-out group-hover:translate-x-0" />
          <span className="relative flex items-center gap-3">
            {cta}
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1.5" />
          </span>
        </Link>
      </Reveal>
    </div>
  </section>
);
